'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = undefined;

var _cell = require('./cell');

let Row = exports.Row = class Row {

  constructor(_ref) {
    let sheet = _ref.sheet;
    this.cells = [];
    this.hidden = false;
    this.height = 0;
    this.outlineLevel = 0;
    this.isCustom = false;

    this.sheet = sheet;
  }
  setHeightCM(ht) {
    this.height = ht * 28.3464567;
    this.isCustom = true;
  }
  addCell() {
    const cell = new _cell.Cell({ row: this });
    this.cells.push(cell);
    this.sheet.maybeAddCol(this.cells.length);
    return cell;
  }
};